(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/leaguebig/assets/javascripts/views/league-big-statistics-view.js') >= 0) return;  svs.modules.push('/components/statistics/leaguebig/assets/javascripts/views/league-big-statistics-view.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.views = svs.statistics.big.views || {};

  svs.statistics.big.views.LeagueBigStatisticsView = Backbone.Marionette.View.extend(
    {
      template: function(data) {
        return svs.statistics.leaguebig.templates.league_big_main(data);
      },
      regions: {
        header: '.league-big-header',
        content: '.league-big-content'
      },
      modelEvents: {
        sync: 'onUpdate'
      },
      log: new svs.core.log.Logger(
        'svs.statistics.views.LeagueBigStatisticsView'
      ),
      initialize: function(options) {
        this.tabSubview = new svs.statistics.big.views.LeagueBigStatisticsTabs({
          model: this.model,
          bigNavRef: options.bigNavRef,
          tab: this.options.tab,
          preDraw: this.options.preDraw
        });
        this.headerSubview = new svs.statistics.big.views.LeagueBigStatisticsHeader(
          { model: this.model, app: options.app }
        );
        this.listenTo(
          this.tabSubview,
          'resizeRoyalSlider',
          this.resizeRoyalSlider
        );
      },
      resizeRoyalSlider: function() {
        this.trigger('resizeRoyalSlider');
      },
      onUpdate: function() {
        if (_.isObject(this.model)) {
          this.options.leagueId = this.model.get('leagueId');
          this.options.label = this.model.get('league').name;
          this.trigger('openRegion', this.options);
        }
      },
      onRender: function() {
        this.showChildView('header', this.headerSubview);
        this.showChildView('content', this.tabSubview);

        if (_.isObject(this.model) && _.isObject(this.model.get('league'))) {
          this.stopListening(this.model, 'sync');
          this.onUpdate();
        } else if (this.options.preDraw) {
          this.trigger('openRegion', this.options);
        }
      },
      onDestroy: function() {
        this.stopListening();

        if (this.header) {
          this.header.empty();
          this.header = null;
        }
        if (this.content) {
          this.content.empty();
          this.content = null;
        }

        this.tabSubview = null;
        this.headerSubview = null;

        delete this.tabSubview;
        delete this.headerSubview;

        if (_.isObject(this.model)) {
          this.model.dispose();
          this.model.stopListening();
          this.model = null;
          delete this.model;
        }

        this.options = null;
        delete this.options;
      }
    }
  );
})(Backbone, _, svs);

 })(window);